import { Dialog } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { CloseGrayIcon } from "../Icon/CloseGrayIcon";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export interface LayerProps {
    renderUI: () => JSX.Element;
    renderTitleUI?: () => JSX.Element;
    renderBottomUI?: () => JSX.Element;
    padding?: string;
    onClose?: () => void;
    showCloseButton?: boolean;
    fullWidth?: boolean;
    fullScreen?: boolean;
    open: boolean;
}

export function UILayer(props: LayerProps) {
    return (
        <LayerRender
            classes={{ root: "Layer-root" }}
            padding={props.padding}
            onClose={props.onClose}
            open={props.open}
            fullScreen={props.fullScreen}
            fullWidth={props.fullWidth}
            maxWidth={false}
        >
            {props.showCloseButton && props.onClose && (
                <CloseButton onClick={props.onClose}>{<CloseGrayIcon />}</CloseButton>
            )}
            {props.renderTitleUI ? props.renderTitleUI() : null}
            {props.renderUI()}
            {props.renderBottomUI ? props.renderBottomUI() : null}
        </LayerRender>
    );
}

const LayerRender = styled(Dialog)<{ padding?: string }>`
    .MuiDialog-paper {
        background: ${UIStyleConstants.WHITE_COLOR};
        border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
        box-sizing: border-box;
        box-shadow: 0px 6px 8px -2px ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
        border-radius: 8px;
        padding: ${(props) => (props.padding ? props.padding : "0px")} !important;

        &.MuiDialog-paperFullScreen {
            border-radius: 0px;
        }
    }
`;

const CloseButton = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
`;
